<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center vh-100"
  >
  
    <div
      v-if="loading"
      class="text-primary d-flex align-items-center gap-3 fs-4 fw-semibold"
    >
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <span>Verifying...</span>
    </div>
   
    <div
      v-else-if="error"
      class="text-danger d-flex flex-column align-items-center gap-3 fs-4 fw-semibold"
    >
      <i class="fas fa-exclamation-circle fa-2x"></i>
      <span class="text-dark">{{ error }}</span>
 
      <button class="btn btn-primary loginbtn mt-3" @click="retry">Login</button>
    </div>
 
    <div
      v-else
      class="text-success d-flex align-items-center gap-3 fs-4 fw-semibold"
    >
      <i class="fas fa-spinner fa-spin fa-2x"></i>
      <span>Verifying...</span>
    </div>
    <div>
      <div>
        <AuthModal
  v-if="showModal"
  :mode="modalMode"
  @close="handleModalClose"
  @switchMode="switchMode"
/>

        <Model v-if="display" @close="handleModalClose">
          <LoginModel :AdPostHeader="AdPostHeader" @close="handleModalClose" />
        </Model>
      </div>
    </div>
  </div>
</template>
 
<script>
import { defineComponent, onMounted, ref, nextTick } from "vue";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import { UAParser } from "ua-parser-js";
import AuthModal from "./pages/Models/AuthModal.vue";
import { getRecaptchaToken } from "@/utils/recaptcha";
export default defineComponent({
  name: "Verify",
components:{
    AuthModal
},
  setup() {
    const loading = ref(true);
    const error = ref("");
    // Long-lived (12h) session token issued once the link is consumed. We store
    // THIS as auth-token, not the short 5-min link token from the URL.
    const sessionToken = ref("");
  const modalMode=ref()
  const showModal=ref(false)
  const display =ref(false)
    const router = useRouter();
    const route = useRoute();
    const AdPostHeader = ref("login");
 
    const verifyLogin = async () => {
      try {
        const email = route.query.email;
        const username = email.split("@")[0];
 
        const recaptchaToken = await getRecaptchaToken('register');
        const registerResponse = await axios.post("/api/register", {
          userName: username,
          email: email,
          secKey: "TempPass123",
          orgInfo: "Temp",
          recaptchaToken,
        });
 
        if (
          registerResponse.status === 200 ||
          registerResponse.status === 201
        ) {
          await handleLogin();
        } else {
          error.value = "Unable to register";
          loading.value = false;
        }
      } catch (err) {
        console.error("Register error:", err.message || err);
        error.value = "Registration failed";
        loading.value = false;
      }
    };
 
    const handleLogin = async () => {
      await nextTick();
      try {
        const userID = route.query.userID;
        const checkResponse = await axios.post("/api/getoneusers", { userID });
        const user = checkResponse.data[0];
 
        // Use the long-lived session token issued at link-consumption time so the
        // session lasts until logout. Fall back to the URL token only if the
        // exchange somehow failed (keeps the old behaviour as a safety net).
        const token = sessionToken.value || route.query.token;
        localStorage.setItem("auth-token", token);
        localStorage.setItem("userid", user.userID);
 
        const logintime = new Date().toISOString();
        localStorage.setItem("logintime", logintime);
 
        const userlogRes = await axios.post("/api/userlog", {
          userID: user.userID,
          loginTime: logintime,
          status: "active",
        });
 
        const userlogid = userlogRes.data.item.userlogId;
        localStorage.setItem("userlogid", userlogid);
 
        await axios.put("/api/updateoneuser", {
          userID: user.userID,
          status: "active",
        });
 
        const parser = new UAParser();
        const browserInfo = parser.getResult();
        const ipRes = await fetch("https://api64.ipify.org?format=json");
        const ip = (await ipRes.json()).ip;
 
        const visitData = {
          userID: user.userID,
          userName: user.userName,
          timestamp: logintime,
          browser: browserInfo.browser.name,
          browserVersion: browserInfo.browser.version,
          os: browserInfo.os.name,
          osVersion: browserInfo.os.version,
          device: browserInfo.device.type || "Desktop",
          screenResolution: `${window.screen.width}x${window.screen.height}`,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          ip,
        };
 
        await axios.post("/api/adminreport", visitData);
 
        window.location.href = "/";
      } catch (err) {
        console.error("Login error:", err.message || err);
        error.value = "Login failed";
        loading.value = false;
      }
    };

    const onEmailSend = async () => {
      const userID = route.query.userID;
      const checkResponse = await axios.post("/api/getoneusers", { userID });
 
      if (checkResponse.data.length >= 1) {
        await handleLogin();
      } else {
        await verifyLogin();
      }
    };
 
const switchMode = (type) => {
  modalMode.value = type;
};

const retry = () => {
  modalMode.value = "login";
  showModal.value = true;
};

const handleModalClose = () => {
  showModal.value = false;
};

 
    onMounted(async () => {
      const token = route.query.token;
 
      try {
        await axios.post(
          "/api/verify-token",
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          }
        );

        // Link is valid -> exchange the short 5-min link token for a fresh
        // long-lived (12h) session token that persists until the user logs out.
        const sessionRes = await axios.post(
          "/api/emaillink-session",
          {},
          {
            headers: { Authorization: `Bearer ${token}` },
            withCredentials: true,
          }
        );
        sessionToken.value = sessionRes.data.token;

        await onEmailSend();
      } catch (err) {
        console.error("Token verify failed:", err.message || err);
        error.value = "Invalid or expired token";
        loading.value = false;
      }
    });
 
    return {
      loading,
      error,
      retry,
      display,
      handleModalClose,
      AdPostHeader,
        showModal,
  modalMode,
  switchMode,
    };
  },
});
</script>
 
<style >
.icon {
  margin-right: 5px;
  vertical-align: middle;
}
.spin {
  animation: spin 1s linear infinite;
}
.loginbtn:hover {
   background-color: #0b5ed7;
  border-color: #0a58ca;
}
@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
 